import { ControlMenu } from 'app/shared/models/control/control-menu';
import { Permission } from 'app/shared/models/control/permission';
import { environment } from 'environments/environment';

export const RoleControlMenu: ControlMenu[] = [
    new ControlMenu(1, 'Certacure', null, []),
    new ControlMenu(2, 'Certacure Control', 1, []),
    new ControlMenu(3, 'Patient Administration System', 1, []),
    new ControlMenu(4, 'Clinical Information System', 1, []),
    new ControlMenu(5, 'Patients Billing Service', 1, []),
    new ControlMenu(6, 'Network', 5, []),
    new ControlMenu(7, 'Contract Station', 6, [
        new Permission('ViewContractStation', 'View Contract Station'),
        new Permission('EnableMohSetup', 'Enable MOH Setup')]),
    new ControlMenu(8, 'Operation Theater Management', 4, []),
    new ControlMenu(9, 'Nursing Management', 4, []),
    new ControlMenu(10, 'Pharmacy Management', 4, []),
    new ControlMenu(11, 'Laboratory Management', 4, []),
    new ControlMenu(14, 'Order Management', 4, []),
    new ControlMenu(17, 'Nursing Station', 9, [
        new Permission('ViewNursingStation', 'View Nursing Station')]),
    new ControlMenu(18, 'Definition', 10, []),
    new ControlMenu(19, 'Management', 10, []),
    new ControlMenu(20, 'Definitions', 18, [
        new Permission('ViewDrugsIndexAndDefinition', 'View Drugs Index And Definition')]),
    new ControlMenu(21, 'Frequencies', 18, [
        new Permission('ViewFrequency', 'View Frequency')]),
    new ControlMenu(22, 'Dispense Medication', 19, [
        new Permission('ViewDispenseMedication', 'View Dispense Medication'),
        new Permission('EnableDispenseCheckBalance', ' Enable Check Balance '),
        new Permission('EnableDispensingDrugforHaltedStatements', 'Enable Dispensing Drug for Halted Statements'),
        new Permission('EnableReferralPrescription', 'Enable Referral Prescription'),
        new Permission('DispenseMedicationPreventOrderOnCreditEncounter', 'Prevent Order On Credit Encounter'),
        new Permission('AllowExcludeDispenseItems', 'Allow Exclude Dispense Items'),
    ]),
    new ControlMenu(23, 'Receive Prescription', 19, [
        new Permission('ViewReceiveDoctorsPrescription', 'View Receive Doctors Prescription'),
        new Permission('EnableReceivedPrescription', 'Enable Received Prescription'),
        new Permission('PreventUserToReceivDispenseSamePrescription', 'Prevent User To Receive/Dispense Same Prescription'),
        new Permission('ReceivePrescriptionEnableEditDoseDetails', 'Enable Edit Dose Details'),
    ]),

    new ControlMenu(24, 'Return Request', 19, [
        new Permission('ViewReturnRequest', 'View Return Request'),
        new Permission('ReturnRequestAllowUserToReturnWithIssueStatement', 'Allow User To Return Even With Issue Invoice'),
    ]),
    new ControlMenu(25, 'Sections', 19, [
        new Permission('ViewSections', 'View Sections')]),
    new ControlMenu(26, 'Doctor Prescription', 19, [
        new Permission('ViewDoctorPrescription', 'View Doctor Prescription')]),
    new ControlMenu(27, 'Return Approve', 19, [
        new Permission('ViewApproveReturnRequest', 'View Approve Return Request'),
        new Permission('ApproveRequestAllowUserToReturnWithIssueStatement', 'Allow User To Return Even With Issue Invoice'),
    ]),
    new ControlMenu(28, 'Pharmacy Release', 19, [
        new Permission('ViewPharmacyRelease', 'View Pharmacy Release')]),
    new ControlMenu(29, 'Medication Product', 19, [
        new Permission('ViewMedicationProduct', 'View Medication Product')]),
    new ControlMenu(30, 'Master Definition', 11, []),
    new ControlMenu(31, 'Transaction', 11, []),
    new ControlMenu(32, 'Results List', 30, [
        new Permission('ViewResultsList', 'View Results List')]),
    new ControlMenu(33, 'Lookups', 30, [
        new Permission('ViewLookups', 'View Lookups')]),
    new ControlMenu(34, 'Sections', 30, [
        new Permission('ViewLabSections', 'View Lab Sections')]),
    new ControlMenu(35, 'Rejection Reason', 30, [
        new Permission('ViewSpecimenRejectionReason', 'View Specimen Rejection Reason')]),
    new ControlMenu(36, 'External Laboratory', 30, [
        new Permission('ViewExternalLaboratory', 'View External Laboratory')]),
    new ControlMenu(37, 'Antibiotics', 30, [
        new Permission('ViewAntibiotics', 'View Antibiotics')]),
    new ControlMenu(38, 'Group Test Profile', 30, [
        new Permission('ViewGroupTestProfile', 'View Group Test Profile')]),
    new ControlMenu(39, 'Tests Definition', 30, [
        new Permission('ViewTestsDefinition', 'View Tests Definition'),
        new Permission('ViewTestMapping', 'View Test Mapping'),
        new Permission('EnablePrintLaboratoryTests', 'Enable Print Laboratory Tests')]),
    new ControlMenu(40, 'Kit Setup', 30, [
        new Permission('ViewKitSetup', 'View Kit Setup')]),
    new ControlMenu(41, 'Microbiology Panel', 30, [
        new Permission('ViewMicrobiologyPanel', 'View Microbiology Panel')]),
    new ControlMenu(42, 'Comment Template', 30, [
        new Permission('ViewCommentTemplate', 'View Comment Template')]),
    new ControlMenu(43, 'Test Result Formula', 30, [
        new Permission('ViewResultFormulaTests', 'View Result Formula Tests')]),
    new ControlMenu(44, 'Test Instructions', 30, [
        new Permission('ViewTestInstruction', 'View Test Instruction')]),
    new ControlMenu(45, 'Text Result Template', 30, [
        new Permission('ViewTextResultsTemplates', 'View Text Results Templates')]),
    new ControlMenu(47, 'Collect Specimen', 31, [
        new Permission('ViewCollectSpecimen', 'View Collect Specimen')]),
    new ControlMenu(48, 'Culture Result', 31, [
        new Permission('ViewCultureResult', 'View Culture Result'),
        new Permission('EnableCompleteOrganismTest', 'Enable Complete Organism Test'),
        new Permission('EnableReleaseOrganismTest', 'Enable Release Organism Test'),
        new Permission('EnableCompleteCultureResult', 'Enable Complete Culture Result'),
        new Permission('EnableReleaseCultureResult', 'Enable Release Culture Result'),
        new Permission('EnableUnReleaseCultureResult', 'Enable Un-Release Culture Result'),
        new Permission('PreventUserWhoCompletesCultureResultToReleaseIt', 'Prevent User Who Completes Culture Result To Release It')]),
    new ControlMenu(49, 'Normal Result', 31, [
        new Permission('ViewNormalResult', 'View Normal Result'),
        new Permission('EnableCompleteNormalResult', 'Enable Complete Normal Result'),
        new Permission('EnableReleaseNormalResult', 'Enable Release Normal Result'),
        new Permission('EnableUnReleaseNormalResult', 'Enable UnRelease Normal Result'),
        new Permission('EnableChangeNormalRanges', 'Enable Change Normal Ranges'),
        new Permission('EnableConfirmNormalResult', 'Enable Confirm Normal Result'),
        new Permission('PreventUserWhoCompletesNormalResultToReleaseIt', 'Prevent User Who Completes Normal Result To Release It')]),
    new ControlMenu(50, 'Workbench', 31, [
        new Permission('ViewWorkbench', 'View Workbench'),
        new Permission('EnableChangeStatusFromCollectedToAccepted', 'Enable Change Status From Collected To Accepted'),
        new Permission('SendResult', 'Send Result'),
        new Permission('EnableChangeStatusFromReleaseToCanceled', 'Enable Change Status From Release To Canceled'),
        new Permission('AllowUserToRemoveExternalAttachment', 'Allow User To Remove External Attachment')
    ]),
    new ControlMenu(51, 'TAT Monitoring Screen', 31, [
        new Permission('ViewTatMonitor', 'View TAT Monitoring Screen')]),

    new ControlMenu(53, 'External Order', 31, [
        new Permission('ViewExternalOrder', 'View External Order')]),
    new ControlMenu(54, 'Search Engine', 31, [
        new Permission('ViewSearchEngine', 'View Search Engine')]),
    new ControlMenu(55, 'Report Result', 31, [
        new Permission('ViewReportResult', 'View Report Result'),
        new Permission('EnableCompleteReportResult', 'Enable Complete Report Result'),
        new Permission('EnableReleaseReportResult', 'Enable Release Report Result'),
        new Permission('ReadOnlyHistopathologyResultTemplate', 'Read-only Histopathology Result Template'),
        new Permission('PreventUserWhoCompletesReportResultToReleaseIt', 'Prevent User Who Completes Report Result To Release It'),
        new Permission('EnablePathologyAndDiseaseByCase', 'Enable Pathology and Disease By Case')
    ]),
    new ControlMenu(56, 'Previous Result', 31, [
        new Permission('ViewPreviousResult', 'View Previous Result')]),
    new ControlMenu(57, 'Order Management', 14, []),
    new ControlMenu(59, 'Patient Order', 57, [
        new Permission('ViewPatientOrder', 'View Patient Order'),
        new Permission('EnableOrderCheckBalance', ' Enable Check Balance'),
        new Permission('EnableOrderforHaltedStatements', 'Enable Order for Halted Statements'),
        new Permission('OrderManagementPreventOrderOnCreditEncounter', 'Prevent Order On Credit Encounter'),
        new Permission('AllowExcludeOrderItems', 'Allow Exclude Order Items'),
    ]),
    new ControlMenu(60, 'Cancel Order', 57, [
        new Permission('ViewCancelOrder', 'View Cancel Order'),
        new Permission('PreventUsertoCancelReceivedRadiologyServices', 'Prevent User to Cancel Received Radiology Services')
    ]),
    new ControlMenu(61, 'User Favorite', 57, [
        new Permission('ViewUserFavorite', 'View User Favorite')]),

    new ControlMenu(63, 'Patient Billing', 5, []),
    new ControlMenu(64, 'Pricing Management', 5, []),
    new ControlMenu(65, 'Business Center', 63, [
        new Permission('IsDisplayResearchPatient', 'Display Research Patient'),
        new Permission('IsChangeServicePayer', 'Change Service Payer'),
    ]),
    new ControlMenu(66, 'Invoice Management', 63, []),
    new ControlMenu(67, 'Approval Follow-up', 65, [
        new Permission('ViewApprovalFollowUp', 'View Approval Follow-up'),
        new Permission('AllowNewCoverage', 'Allow New Coverage'),
        new Permission('AllowPreApproval', 'Allow Pre Approval'),
        new Permission('EnableExtendApprovalPeriod', 'Enable Extend Approval Period'),
        new Permission('EnableTransferApproval', 'Enable Transfer Approval'),
        new Permission('EnableRenewApproval', 'Enable Renew Approval'),
        new Permission('EnableCancelApproval', 'Enable Cancel Approval'),
        new Permission('EnableChangeStatus', 'Enable Change Status'),
        new Permission('EnableApprovalNotify', 'Enable Approval Notify'),
        new Permission('ApprovalDetailsViewOnly', 'Approval Details View Only'),
        new Permission('PrintApprovalApplicationForm', 'Print Approval Application Form'),

    ]),
    new ControlMenu(68, 'Coverage Letter', 65, [
        new Permission('ViewCoverageLetter', 'View Coverage Letter'),
        new Permission('AllowCalculatePercentage', 'Allow Calculate Percentage')
    ]),
    new ControlMenu(69, 'Accommodation Fees', 66, [
        new Permission('ViewAccommodationFees', 'View Accommodation Fees')]),
    new ControlMenu(70, 'Business Center', 66, [
        new Permission('ViewBusinessCenter', 'View Business Center')]),
    new ControlMenu(71, 'Encounter Details', 66, [
        new Permission('ViewEncounterDetails', 'View Encounter Details'),
        new Permission('EnableDischargedDate', 'Enable Discharged Date')]),
    new ControlMenu(73, 'Accommodation', 66, [
        new Permission('ViewAccommodation', 'View Accommodation')]),
    new ControlMenu(74, 'Package Session', 66, [
        new Permission('ViewPackageSession', 'View Package Session')]),
    new ControlMenu(76, 'Bill Serials', 66, [
        new Permission('ViewBillSerials', 'View Bill Serials')]),
    new ControlMenu(77, 'Pricing List', 64, [
        new Permission('ViewPricingList', 'View Pricing List')]),
    new ControlMenu(78, 'Item Pricing', 64, [
        new Permission('ViewItemPricing', 'View Item Pricing')]),
    new ControlMenu(79, 'Copy Price List', 64, [
        new Permission('ViewCopyPriceList', 'View Copy Price List')]),
    new ControlMenu(80, 'In-Patient Management', 3, []),
    new ControlMenu(81, 'Schedule And Appointment', 3, []),
    new ControlMenu(82, 'Emergency Management', 3, []),
    new ControlMenu(83, 'Outpatient Management', 3, []),
    new ControlMenu(84, 'Medical Records', 3, []),
    new ControlMenu(86, 'Waiting List', 80, [
        new Permission('ViewWaitingList', 'View Waiting List')]),
    new ControlMenu(87, 'New Admission', 80, [
        new Permission('ViewNewAdmission', 'View New Admission')]),
    new ControlMenu(88, 'PreAdmission', 80, [
        new Permission('ViewPreAdmission', 'View PreAdmission')]),
    new ControlMenu(89, 'Companion', 80, [
        new Permission('ViewCompanion', 'View Companion')]),
    new ControlMenu(90, 'Transfer', 80, [
        new Permission('ViewTransfer', 'View Transfer')]),
    new ControlMenu(91, 'Discharge', 80, [
        new Permission('ViewDischarge', 'View Discharge')]),
    new ControlMenu(92, 'Cancel Admission', 80, [
        new Permission('ViewCancelAdmission', 'View Cancel Admission')]),
    new ControlMenu(93, 'Admission Station', 80, [
        new Permission('ViewAdmissionStation', 'View Admission Station')]),
    new ControlMenu(95, 'Resource', 81, [
        new Permission('ViewResource', 'View Resource')]),
    new ControlMenu(96, 'Schedule', 81, [
        new Permission('ViewSchedule', 'View Schedule')]),
    new ControlMenu(97, 'Appointments', 81, [
        new Permission('ViewAppointments', 'View Appointments')]),
    new ControlMenu(98, 'Emergency Station', 82, [
        new Permission('ViewEmergencyStation', 'View Emergency Station'),
        new Permission('EnableReopenEmergencyEncounter', 'Reopen Emergency Encounter'),
        new Permission('EnableViewEmergencyPatientDiagnosis', 'Enable View Patient Diagnosis'),
        new Permission('AllowShowTriage', 'Allow Triage'),
        new Permission('AllowCancelEncounterInEmergencyStation', 'Allow Cancel Encounter'),
    ]),
    new ControlMenu(99, 'Emergency Visit', 82, [
        new Permission('ViewEmergencyVisit', 'View Emergency Visit'),
        new Permission('AllowAddEmergencyVisitWithBackdated', 'Allow User to Add Emergency Visit with Backdated'),
        new Permission('AllowToAddEmergencyVisitWithFutureDate', 'Allow User to Add Emergency Visit with Future Date')]),
    new ControlMenu(100, 'Transactions', 83, [
        new Permission('ViewTransactions', 'View Transactions'),
        new Permission('EnableReopenOutpatientEncounter', 'Reopen Outpatient Encounter'),
        new Permission('EnableViewOutpatientDiagnosis', 'Enable View Patient Diagnosis'),
        new Permission('AllowOpenOutVisitToAdmittedPatient', 'Allow Open Out Visit to Admitted Patient'),
        new Permission('AllowToAddOutVisitWithBackDated', 'Allow User to Add Out Visit with BackDated'),
        new Permission('AllowToAddOutVisitWithFutureDate', 'Allow User to Add Out Visit with Future Date'),
        new Permission('AllowCancelEncounterInOutPatientTransaction', 'Allow Cancel Encounter')
    ]),
    new ControlMenu(101, 'File Request', 83, [
        new Permission('ViewFileRequest', 'View File Request'),
        new Permission('DisablePrice', 'Disable Price')]),
    new ControlMenu(102, 'Medical File Requisition', 84, []),
    new ControlMenu(103, 'Patient File History', 84, [
        new Permission('ViewPatientFileHistory', 'View Patient File History')]),
    new ControlMenu(104, 'Merge File', 84, []),
    new ControlMenu(105, 'Request File', 102, [
        new Permission('ViewRequestFile', 'View Request File')]),
    new ControlMenu(110, 'Patient File Merge', 104, [
        new Permission('ViewPatientFileMerge', 'View Patient File Merge')]),
    new ControlMenu(111, 'Companion Details', 80, [
        new Permission('ViewCompanionDetails', 'View Companion Details')]),
    new ControlMenu(112, 'Hospital Sections', 80, [
        new Permission('ViewHospitalSections', 'View Hospital Sections')]),
    new ControlMenu(113, 'Service Price Category', 64, [
        new Permission('ViewServicePriceCategory', 'View Service Price Category')]),
    new ControlMenu(114, 'Contracts', 6, [
        new Permission('ViewContracts', 'View Contracts')]),
    new ControlMenu(115, 'Policy', 6, [
        new Permission('ViewPolicy', 'View Policy')]),
    new ControlMenu(125, 'Triage', 9, [
        new Permission('ViewTriage', 'View Triage')]),
    new ControlMenu(126, 'Generic Configuration', 19, [
        new Permission('ViewGenericConfiguration', 'View Generic Configuration')]),
    new ControlMenu(127, 'Medication Administration', 19, [
        new Permission('ViewMedicationAdministration', 'View Medication Administration')]),
    new ControlMenu(128, 'Result List Details', 30, [
        new Permission('ViewResultListDetails', 'View Result List Details')]),
    new ControlMenu(129, 'Group Tests Details', 30, [
        new Permission('ViewGroupTestsDetails', 'View Group Tests Details')]),
    new ControlMenu(130, 'Test Normal Range', 30, [
        new Permission('ViewTestNormalRange', 'View Test Normal Range')]),
    new ControlMenu(131, 'Microbiology Panel Antibiotic', 30, [
        new Permission('ViewMicrobiologyPanelAntibiotic', 'View Microbiology Panel Antibiotic')]),
    new ControlMenu(132, 'Result Formula Tests Details', 30, [
        new Permission('ViewResultFormulaTestsDetails', 'View Result Formula Tests Details')]),
    new ControlMenu(133, 'Test Instruction Details', 30, [
        new Permission('ViewTestInstructionDetails', 'View Test Instruction Details')]),

    new ControlMenu(135, 'Security And Privileges', 2, [
        new Permission('ViewUserManagement', 'View User Management'),
        new Permission('ViewCopyUserRolesAndPrivileges', 'View Copy User Roles and Privileges'),
        new Permission('ViewUserReport', 'View User Report'),
    ]),

    new ControlMenu(136, 'System Parameter', 2, []),
    new ControlMenu(137, 'Item Structure', 2, []),

    new ControlMenu(139, 'Dashboard', 2, []),
    new ControlMenu(140, 'Item Instruction', 136, [
        new Permission('ViewItemInstruction', 'View Item Instruction')]),
    new ControlMenu(141, 'Diagnosis', 136, [
        new Permission('ViewDiagnosis', 'View Diagnosis')]),
    new ControlMenu(142, 'Allergy', 136, [
        new Permission('ViewAllergy', 'View Allergy')]),
    new ControlMenu(143, 'Facility', 136, [
        new Permission('ViewFacility', 'View Facility')]),
    new ControlMenu(144, 'Medical Categories', 136, [
        new Permission('ViewMedicalCategories', 'View Medical Categories')]),
    new ControlMenu(145, 'System Codes', 136, [
        new Permission('ViewSystemCodes', 'View System Codes')]),
    new ControlMenu(146, 'Clinical Notes', 136, [
        new Permission('ViewClinicalNotes', 'View Clinical Notes')]),
    new ControlMenu(147, 'Admission Reason', 136, [
        new Permission('ViewAdmissionReason', 'View Admission Reason')]),
    new ControlMenu(148, 'Classes', 136, [
        new Permission('ViewClasses', 'View Classes')]),
    new ControlMenu(149, 'Rooms', 136, [
        new Permission('ViewRooms', 'View Rooms')]),
    new ControlMenu(150, 'Consultation Types', 136, [
        new Permission('ViewConsultationTypes', 'View Consultation Types')]),
    new ControlMenu(151, 'Clinic & Doctor', 136, [
        new Permission('ViewClinicAndDoctor', 'View Clinic And Doctor')]),
    new ControlMenu(153, 'System Codes Details', 136, [
        new Permission('ViewSystemCodesDetails', 'View System Codes Details')]),
    new ControlMenu(154, 'Beds', 136, [
        new Permission('ViewBeds', 'View Beds')]),
    new ControlMenu(155, 'Items', 137, [
        new Permission('ViewItems', 'View Items'),
        new Permission('AddNewService', 'Add New Service'),]),
    new ControlMenu(156, 'Parent Items', 137, [
        new Permission('ViewParentItems', 'View Parent Items')]),
    new ControlMenu(157, 'Package Items', 137, [
        new Permission('ViewPackageItems', 'View Package Items')]),
    new ControlMenu(158, 'Group Items', 137, [
        new Permission('ViewGroupItems', 'View Group Items')]),
    new ControlMenu(159, 'Order Set Items', 137, [
        new Permission('ViewOrderSetItems', 'View Order Set Items')]),
    new ControlMenu(168, 'Billing Center Transactions', 66, [
        new Permission('ViewBillingCenterTransactions', 'View Billing Center Transactions'),
        new Permission('EnablePatientDownPayment', 'Enable Patient Down Payment'),
        new Permission('EnablePatientValidateStatement', 'Enable Patient Validate Statement'),
        new Permission('EnablePatientAddDiscount', 'Enable Patient Add Discount'),
        new Permission('EnablePatientReOpenStatement', 'Enable Patient Re-Open Statement'),
        new Permission('EnablePatientIssueBill', 'Enable Patient Issue Bill'),
        new Permission('EnablePatientFinanceRelease', 'Enable Patient Finance Release'),
        new Permission('EnablePatientHaltStatements', 'Enable Patient Halt Statements'),
        new Permission('EnablePatientOpenHaltStatements', 'Enable Patient Open Halt Statements'),
        new Permission('EnableCancelDownPaymentTransaction', 'Enable Cancel Down Payment Transaction'),
        new Permission('EnableCancelDiscountTransaction', 'Enable Cancel Discount Transaction'),
        new Permission('EnableCancelInvoiceTransaction', 'Enable Cancel Invoice Transaction'),
        new Permission('EnableSettlement', 'Enable Settlement'),
        new Permission('EnablePatientBlockStatements', 'Enable Patient Block Statements'),
        new Permission('EnablePatientUnBlockStatements', 'Enable Patient UnBlock Statements'),
        new Permission('EnablePrintInvoiceSummaryReport', 'Enable Print Invoice Summary Report'),
        new Permission('EnablePatientRefund', 'Enable Patient Refund'),
        new Permission('EnableEditPatientRefundAmount', 'Enable Edit Patient Refund Amount'),
        new Permission('PreventUserPrintUnissuedAndUnpaidInvoicesReport', 'Prevent User Print Unissued And Unpaid Invoices Report'),
        new Permission('EnableAddDonorInvoice', 'Enable Add Donor Invoice'),
        new Permission('EnableCancelSettlementTransaction', 'Enable Cancel Settlement Transaction'),
        new Permission('AllowUserToAddNewAccommodation', 'Allow User To Add New Accommodation'),
        new Permission('EnablePrintTransaction', 'Enable Print Transaction'),
        new Permission('PrintCopyInvoice', 'Print Copy Invoice'),
    ]),
    new ControlMenu(169, 'Doctor Release', 80, [
        new Permission('ViewDoctorRelease', 'View Doctor Release'),
        new Permission('DiscontinueMedicationWhenDoctorRelease', 'Discontinue Medication When Doctor Release')]),
    new ControlMenu(170, 'Post Pending Transaction', 57, [
        new Permission('ViewPostPendingTransaction', 'View Post Pending Transaction')]),
    new ControlMenu(171, 'Today Cash Box', 66, [
        new Permission('ViewTodayCashBox', 'View Today Cash Box')]),
    new ControlMenu(172, 'Main Fund', 66, [
        new Permission('ViewMainFund', 'View Main Fund'),
        new Permission('EnableCalculateFund', 'Enable Calculate Fund')]),
    new ControlMenu(173, 'Integration Control', 2, []),
    new ControlMenu(174, 'Sap Control', 173, [
        new Permission('ViewSapControl', 'View Sap Control')]),
    new ControlMenu(175, 'Reports', 63, [
        new Permission('ViewBillingReport', 'View Reports'),
    ]),
    new ControlMenu(176, 'Patient Balance', 63, [
        new Permission('ViewPatientBalance', 'View Patient Balance')
    ]),

    new ControlMenu(176, 'Tracking Main Fund', 66, [
        new Permission('ViewTrackingMainFund', 'View Tracking Main Fund'),
        new Permission('EnableAcceptRejectRequest', 'Enable Accept/Reject Request'),
    ]),
    new ControlMenu(177, 'Issued Invoice', 175, [
        new Permission('ViewIssuedInvoice', 'View Issued Invoice')]),
    new ControlMenu(178, 'Unissued Invoice', 175, [
        new Permission('ViewUnissuedInvoice', 'View Unissued Invoice')]),
    new ControlMenu(179, 'In-Patient Report', 3, []),
    new ControlMenu(180, 'Activities Report', 179, [
        new Permission('ViewActivitiesReport', 'View Activities Report')]),
    new ControlMenu(182, 'Profit Margin Configuration', 64, [
        new Permission('ViewProfitMarginConfiguration', 'View Profit Margin Configuration')]),
    new ControlMenu(183, 'Staff Item Categories', 136, [
        new Permission('ViewStaffCategoriesItem', 'View Staff Categories Item')]),
    new ControlMenu(184, 'Nursing Station Configuration', 9, [
        new Permission('ViewNursingStationConfiguration', 'View Nursing Station Configuration')]),
    new ControlMenu(185, 'Pharmacy Daily Work Index', 19, [
        new Permission('ViewPharmacyDailyWorkIndex', 'View Pharmacy Daily Work Index'),
        new Permission('PharmacyDailyWorkIndexAllowUserToReturnWithIssueStatement', 'Allow User To Return Even With Issue Invoice'),
    ]),
    new ControlMenu(186, 'Audit Order', 57, [
        new Permission('ViewAuditOrder', 'View Audit Order'),
        new Permission('EnableChangeOrderDoctor', 'Enable Change Order Doctor'),
        new Permission('EnableChangeInvoiceElement', 'Enable Change Invoice Element'),
        new Permission('EnableCancelOrder', 'Enable Cancel Order'),
        new Permission('ViewExcludeOrderServiceButton', 'View Exclude Order Service Button'),
    ]),
    new ControlMenu(187, 'Copy Payer Details', 66, [
        new Permission('ViewCopyPayerDetails', 'View Copy Payer Details')]),
    new ControlMenu(189, 'Laboratory Reports', 11, []),
    new ControlMenu(190, 'Laboratory Tests Report', 189, [
        new Permission('ViewLaboratoryTestsReport', 'View Laboratory Tests Report')]),
    new ControlMenu(191, 'Monthly Admissions Statistics Report', 179, [
        new Permission('ViewMonthlyAdmissionsStatisticsReport', 'View Monthly Admissions Statistics Report')]),
    new ControlMenu(192, 'Staff Definition', 136, [
        new Permission('ViewStaffDefinition', 'View Staff Definition')]),
    new ControlMenu(193, 'Medical Diagnosis Search Engine', 179, [
        new Permission('ViewMedicalDiagnosisSearchEngine', 'View Medical Diagnosis Search Engine')]),
    new ControlMenu(197, 'Statement Transactions', 66, [
        new Permission('ViewStatementTransactions', 'View Statement Transactions'),
        new Permission('AllowCancelInvoiceInLockedPeriod', 'Allow Cancel Invoice in Locked Period')]),
    new ControlMenu(199, 'Claim Management', 5, []),
    new ControlMenu(200, 'Claim Management Station', 199, [
        new Permission('ViewClaimManagementStation', 'View Claim Management Station')]),
    new ControlMenu(201, 'Claim Management Tracking', 199, [
        new Permission('ViewClaimManagementTracking', 'View Claim Management Tracking'),
        new Permission('EnableCancelEClaim', 'Enable Cancel EClaim'),
        new Permission('EnableVerified', 'Enable Verified')]),
    new ControlMenu(205, 'Income Hospital Report', 175, [
        new Permission('ViewIncomeHospitalReport', 'View Income Hospital lReport')]),
    new ControlMenu(206, 'Organization Section', 136, [
        new Permission('ViewOrganizationSection', 'View Organization Section')]),
    new ControlMenu(208, 'User Sections', 136, [
        new Permission('ViewUserSections', 'View User Sections')]),
    new ControlMenu(209, 'PACS Control', 173, [
        new Permission('ViewPACSControl', 'View PACS Control')]),
    new ControlMenu(213, 'Settlement Tracking', 199, [
        new Permission('ViewclaimSettlementsStation', 'View Claim Settlement Station'),
        new Permission('EnableCompleteStatus', 'Enable Complete Status'),
        new Permission('EnableApprovedStatus', 'Enable Approve Status'),
        new Permission('AddSettlement', 'Enable Add Settlement')]),
    new ControlMenu(215, 'Receipt', 199, [
        new Permission('ViewReceipt', 'View Receipt'),
        new Permission('AddReceipt', 'Add Receipt')]),
    new ControlMenu(216, 'Revenue Section Definition', 136, [
        new Permission('ViewRevenueSectionDefinition', 'View Revenue Section Definition')]),
    new ControlMenu(218, 'Bank', 136, [
        new Permission('ViewBank', 'View Bank')]),
    new ControlMenu(219, 'Hospital Performance Dashboard', 139, [
        new Permission('ViewHospitalPerformanceDashboard', 'View Hospital Performance Dashboard')]),
    new ControlMenu(220, 'New Doctor Performance Dashboard', 139, [
        new Permission('ViewNewDoctorPerformanceDashboard', 'View New Doctor Performance Dashboard')]),
    new ControlMenu(221, 'LIS Control', 173, [
        new Permission('ViewLISControl', 'View LIS Control')]),
    new ControlMenu(222, 'Hospital Rooms', 80, [
        new Permission('ViewHospitalRooms', 'View Hospital Rooms'),
        new Permission('AllowUserToChangeBedStatus', 'Allow User to Change Bed Status'),
    ]),
    new ControlMenu(223, 'Admission Report', 179, [
        new Permission('ViewAdmissionReport', 'View Admission Report')]),
    new ControlMenu(244, 'Section Revenue By Doctor Report', 189, [
        new Permission('ViewSectionRevenueByDoctorReport', 'View Section Revenue By Doctor Report')]),
    new ControlMenu(245, 'Laboratory Patient Visit Report', 189, [
        new Permission('ViewLaboratoryPatientVisitReport', 'View Laboratory Patient Visit Report')]),
    new ControlMenu(246, 'Micro Organism Results Report', 189, [
        new Permission('ViewMicroOrganismResultsReport', 'View Micro Organism Results Report')]),
    new ControlMenu(247, 'Price List Item Report', 64, [
        new Permission('ViewPriceListItemReport', 'View Price List Item Report')]),

    new ControlMenu(250, 'Privilege Report', 1, [
        new Permission('ViewPrivilegeReport', 'View Privilege Report')]),

    new ControlMenu(252, 'Doctor Revenue Per Patient Report', 175, [
        new Permission('ViewDoctorRevenuePerPatientReport', 'View Doctor Revenue Per Patient Report')]),
    new ControlMenu(253, 'Patient Diagnosis', 9, [
        new Permission('ViewPatientDiagnosis', 'View Patient Diagnosis')]),
    new ControlMenu(254, 'Income Per Out-Patient Section Report', 175, [
        new Permission('ViewIncomePerOutPatientSectionReport', 'View Income Per Out Patient Section Report')]),
    new ControlMenu(255, 'Pharmacy Order Management', 19, [
        new Permission('ViewPharmacyOrderManagement', 'View Pharmacy Order Management'),
        new Permission('AllowUpdatePharmacyPatientInfo', 'Allow Update Patient Info')
    ]),
    new ControlMenu(255, 'Lab Order Management', 31, [
        new Permission('ViewLabOrderManagement', 'View Lab Order Management'),
        new Permission('AllowUpdateLabPatientInfo', 'Allow Update Patient Info')
    ]),
    new ControlMenu(256, 'Assignment', 136, [
        new Permission('ViewAssignment', 'View Assignment')]),
    new ControlMenu(257, 'Care Plan Shortcut', 136, [
        new Permission('ViewCarePlanShortcut', 'View Care Plan Shortcut')]),
    new ControlMenu(258, 'Claim Management Mapping', 136, [
        new Permission('ViewClaimManagementMapping', 'View Claim Management Mapping')]),
    new ControlMenu(259, 'Receive Order', 57, [
        new Permission('ViewReceiveOrder', 'View Receive Order'),
        new Permission('EnableChangeToReceiveStatus', 'Enable Change To Receive Status'),
        new Permission('EnableChangeToCompleteStatus', 'Enable Change To Complete Status'),
        new Permission('EnableChangeToLowerStatus', 'Enable Change To Lower Status'),
        new Permission('AbilityToPrintRadiologyReport', 'Ability To Print Radiology Report'),
        new Permission('AccessMedicalProceduresReport', 'Access Medical Procedures Report'),
        new Permission('Attachments', 'Attachments')
    ]),
    new ControlMenu(260, 'Specimen Report', 189, [
        new Permission('ViewSpecimenReport', 'View Specimen Report'),
        new Permission('ViewLabOrderManagement', 'View Lab Order Management')]),
    new ControlMenu(261, 'Appointment Tracking', 81, [
        new Permission('ViewAppointmentTracking', 'View Appointment Tracking')]),
    new ControlMenu(262, 'Transfer Appointment', 81, [
        new Permission('ViewTransferAppointment', 'View Transfer Appointment')]),
    new ControlMenu(263, 'Book Appointment', 81, [
        new Permission('ViewBookAppointment', 'View Book Appointment')]),
    new ControlMenu(264, 'Cancel Appointment', 81, [
        new Permission('ViewCancelAppointment', 'View Cancel Appointment')]),
    new ControlMenu(265, 'Recurring Appointment', 81, [
        new Permission('ViewRecurringAppointment', 'View Recurring Appointment')]),
    //new ControlMenu(254, 'Resource Period', 81, [
    //        new Permission('ViewResourcePeriod', 'View Resource Period')]),
    new ControlMenu(266, 'Appointment Report', 81, [
        new Permission('ViewReportAppointmentList', 'View Report Appointment List')]),
    new ControlMenu(267, 'Unit Dose Drug Distribution', 19, [
        new Permission('ViewUnitDoseDrugDistribution', 'View Unit Dose Drug Distribution'),
        new Permission('AllowToDispenseNRMedications', 'Allow To Dispense NR Medications'),
        new Permission('EnableCheckBalance', 'Enable Check Balance'),
        new Permission('UnitDoseEnableEditDoseDetails', 'Enable Edit Dose Details'),
    ]),
    new ControlMenu(268, 'Medi-Span Setting', 136, [
        new Permission('ViewMedispanSetting', 'View Medi-Span Setting')]),
    new ControlMenu(269, 'Doctor Speciality', 136, [
        new Permission('ViewDoctorsSpeciality', 'Doctor Speciality')]),


    new ControlMenu(271, 'Report Template', 30, [
        new Permission('ViewReportTemplate', 'View Report Template')]),
    new ControlMenu(273, 'RemittanceTransaction', 199, [
        new Permission('ViewRemittanceTransaction', 'View Remittance Transaction')]),
    new ControlMenu(274, 'Sap UnPosted Transactions', 173, [
        new Permission('ViewSapUnPostedTransactions', 'View Sap UnPosted Transactions'),
        new Permission('EnableRefreshVendorCode', 'Enable Refresh Vendor Code'),
        new Permission('EnableRefreshARAccount', 'Enable Refresh AR Account')
    ]),

    new ControlMenu(275, 'Doctor Settlement', 5, []),

    new ControlMenu(276, 'In-Patient Management Reports', 3, [
        new Permission('VieIn-PatientManagementReports', 'View In-Patient Management Reports')]),

    new ControlMenu(277, 'Appointment Reports', 3, [
        new Permission('ViewScheduleAndAppointmentReport', 'View Schedule & Appointment Reports')]),

    new ControlMenu(278, 'Appointment List Reports', 277, [
        new Permission('ViewAppointmentListReport', 'View Appointment List Reports')]),

    new ControlMenu(279, 'Emergency Reports', 3, [
        new Permission('ViewEmergencyReports', 'View Emergency Reports')]),

    new ControlMenu(280, 'Outpatient Reports', 3, [
        new Permission('ViewOutPatientReports', 'View Outpatient Reports')]),

    new ControlMenu(281, 'Equipment Definition', 8, [
        new Permission('ViewEquipmentDefinition', 'View Equipment Definition')]),

    new ControlMenu(282, 'Room Definition', 8, [
        new Permission('ViewRoomDefinition', 'View Room Definition')]),

    new ControlMenu(283, 'Procedure Definition', 8, [
        new Permission('ViewProcedureDefinition', 'View Procedure Definition')]),

    // new ControlMenu(284, 'Operation Tracking', 8, [
    //     new Permission('ViewOperationTracking', 'View Operation Tracking')]),

    new ControlMenu(285, 'Operation Slate', 8, [
        new Permission('ViewOperationSlate', 'View Operation Slate')]),

    new ControlMenu(286, 'Booking', 8, [
        new Permission('ViewBooking', 'View Booking')]),

    new ControlMenu(287, 'Operation Inbox', 8, [
        new Permission('ViewOperationInbox', 'View Operation Inbox')]),

    // new ControlMenu(288, 'Operatio nDashboard', 8, [
    //     new Permission('ViewOperationDashboard', 'View Operation Dashboard')]),

    new ControlMenu(289, 'Nursing Supervisor', 9, [
        new Permission('ViewNursingSupervisor', 'View Nursing Supervisor')]),

    new ControlMenu(290, 'Nursing Timeline', 9, [
        new Permission('ViewNursingTimeline', 'View Nursing Timeline'),
        new Permission('PreventNurseUpdateClosedMedicalRecord', 'Prevent Update Closed Medical Record'),
        new Permission('EnableOncologyMedicationSequence', 'Enable Oncology Medication Sequence'),
        new Permission('AllowNurseToUpdateBlockedFile', 'Allow User To Update Blocked File '),
        new Permission('AllowNurseToRemovePatientAttachment', 'Allow User To Remove Patient Attachment')
    ]),

    new ControlMenu(291, 'Reports', 10, [
        new Permission('ViewPharmacyReports', 'View Reports')]),

    new ControlMenu(292, 'Reports', 11, [
        new Permission('ViewLaboratoryReports', 'View Reports')]),

    new ControlMenu(293, 'Radiology Report', 4, [
        new Permission('ViewRadiologyReport', 'View Radiology Report'),
        new Permission('ViewRadiologyItemReport', 'View Radiology Item Report'),
        new Permission('PreventUserWhoAddReportToApproveIt', 'Prevent User Who Add Report To Approve It'),
        new Permission('EnableEditingOfDraftReports', 'Enable Editing Of Draft Reports')]),

    new ControlMenu(295, 'Smart Form Linkage Configuration', 136, [
        new Permission('ViewSmartconfig', 'View Smart Form Linkage Configuration')]),

    new ControlMenu(296, 'Doctor Specialty', 136, [
        new Permission('ViewDoctorsSpecialty', 'View Doctor Specialty')]),

    new ControlMenu(298, 'Payment Management', 275, []),

    new ControlMenu(299, 'Doctor Fees Station', 298, [
        new Permission('ViewDoctorFeesStation', 'View Doctor Fees Station')]),

    new ControlMenu(300, 'Payment Tracking', 298, [
        new Permission('ViewPaymentTracking', 'View Payment Tracking'),
        new Permission('AllowUserToCancelPayment', 'Allow User To Cancel Payment'),
        new Permission('AllowUserToApprovePayment', 'Allow User To Approve Payment')
    ]),

    new ControlMenu(301, 'Dasbhoard', 1, [
        new Permission('EnableEditWidget', 'Enable Edit Widgets'),
        new Permission('ViewSqlBuilder', 'View Sql Builder Engine'),
    ]),
    new ControlMenu(302, 'Admission Report Setup', 80, [
        new Permission('ViewAdmissionReportSetup', 'View Admission Report Setup')]),

    new ControlMenu(303, 'Password Policy', 136, [
        new Permission('ViewPasswordPolicy', 'View Password Policy')]),

    new ControlMenu(305, 'Order Summary By Item Report', 175, [
        new Permission('ViewOrderSummaryItemReport', 'View Order Summary By Item Report')
    ]),

    new ControlMenu(306, 'Diagnosis Group', 136, [
        new Permission('ViewDiagnosisGroups', 'View Diagnosis Group')]),

    new ControlMenu(307, 'Revenue Report', 175, [
        new Permission('ViewRevenueReport', 'View Revenue Report')
    ]),

    new ControlMenu(308, 'Settlement Deduction Setup', 136, [
        new Permission('ViewSettlementDeductionSetup', 'View Settlement Deduction Setup')]),

    new ControlMenu(309, 'Order Management', 83,
        [new Permission('ViewOutPatientOrderManagement', 'View Order Management'),
        new Permission('AllowUpdateOrderPatientInfo', 'Allow Update Patient Info')]),

    new ControlMenu(310, 'Lab Monitor', 31, [
        new Permission('ViewLabMonitor', 'View Monitor')]),

    new ControlMenu(311, 'Medication File Setup', 136, [
        new Permission('ViewMedicationFileSetup', 'View Medication File Setup')]),

    new ControlMenu(312, 'Consulting Doctors', 80, [
        new Permission('ViewConsultingDoctors', 'View Consulting Doctors')]),

    new ControlMenu(313, 'Notification Roles', 136, [
        new Permission('ViewNotificationRoles', 'View Notification Roles')]),

    new ControlMenu(314, 'Operation Report', 8, [
        new Permission('ViewOperationReport', 'View Reports')]),

    new ControlMenu(315, 'Setup', 2, []),

    new ControlMenu(316, 'CPOE Setup', 315, [
        new Permission('ViewCPOESetup', 'View CPOE Setup'),
        new Permission('ViewVitalSignsBySpecialty', 'View Vital Signs By Specialty'),
        new Permission('ViewSideMenuConfigurationSetup', 'View Side Menu Configuration Setup'),
    ]),

    new ControlMenu(317, 'PBL Setup', 315, [
        new Permission('ViewPBLSetup', 'View PBL Setup')]),

    new ControlMenu(318, 'Billing Setup', 315, []),

    new ControlMenu(319, 'Clinical Documentaion Setup', 315, [
        new Permission('ViewClinicalDocumentaionSetup', 'View Clinical Documentaion Setup')]),

    new ControlMenu(160, 'Cashier Discount', 318, [
        new Permission('ViewCashierDiscount', 'View Cashier Discount')]),
    new ControlMenu(161, 'Configuration Details', 318, [
        new Permission('ViewConfigurationDetails', 'View Configuration Details')]),
    new ControlMenu(162, 'Cashier Definition', 318, [
        new Permission('ViewCashierDefinition', 'View Cashier Definition')]),
    new ControlMenu(163, 'Element Configuration', 318, [
        new Permission('ViewElementConfiguration', 'View Element Configuration')]),
    new ControlMenu(164, 'Transaction Type', 318, [
        new Permission('ViewTransactionType', 'View Transaction Type')]),
    new ControlMenu(165, 'Visa Type', 318, [
        new Permission('ViewVisaType', 'View Visa Type')]),
    new ControlMenu(272, 'Fund', 318, [
        new Permission('ViewFund', 'View Fund')]),
    new ControlMenu(338, 'Charging Setup', 318, [
        new Permission('ViewChargingSetup', 'View Charging Setup')]),
    new ControlMenu(355, 'Billing Setup Page', 318, [
        new Permission('ViewBillingSetupPage', 'View Billing Setup PAge')]),

    new ControlMenu(320, 'Oncology Setup', 315, []),

    new ControlMenu(321, 'Oncology Lookup Definition', 320, [
        new Permission('ViewOncologyLookupDefinition', 'View Oncology Lookup Definition')]),

    new ControlMenu(322, 'Oncology Protocol Definition', 320, [
        new Permission('ViewOncologyProtocolDefinition', 'View Oncology Protocol Definition')]),

    new ControlMenu(323, 'Notification Setup', 315, [
        new Permission('ViewSMSSetup', 'View Notification Setup'),
        new Permission('ViewManualSMSetup', 'View Manual SMS Sending Setup'),
        new Permission('ViewWhatsappSetup', 'View Whatsapp Setup'),
    ]),

    new ControlMenu(324, 'Receive Order Setup', 136, [
        new Permission('ViewReceiveOrderSetup', 'View Receive Order Setup')]),

    new ControlMenu(325, 'Out Patient Monitor', 83,
        [new Permission('ViewOutPatientMonitor', 'View Out Patient Monitor')]),

    new ControlMenu(326, 'Payer Template', 136, [
        new Permission('ViewPayerTemplate', 'View Payer Template')]),

    new ControlMenu(327, 'Medical File Setup', 315, [
        new Permission('ViewMedicalFileSetup', 'View Medical File Setup')]),

    new ControlMenu(328, 'Radiology Setups', 315, []),

    new ControlMenu(329, 'Medical Templates', 136, [
        new Permission('ViewMedicalTemplates', 'View Medical Templates')]),

    new ControlMenu(330, 'Radiology Setup', 328, [
        new Permission('ViewRadiologySetup', 'View Radiology Setup')]),

    new ControlMenu(331, 'MRN Setup', 315, [
        new Permission('ViewMRNSetup', 'MRN Setup')
    ]),

    new ControlMenu(322, 'Mobile Setup', 315, [
        new Permission('ViewMobileSetup', 'View Mobile Setup')
    ]),

    new ControlMenu(332, 'Print Template Setup', 315, [
        new Permission('ViewPrintTemplateSetup', 'View Print Template Setup')]),

    new ControlMenu(333, 'Pending Area', 57, [
        new Permission('ViewPendingArea', 'View Pending Area'),
        new Permission('AllowUserToSeeApproval', 'Allow User To See Approval')
    ]),

    new ControlMenu(334, 'Patient Session', 66, [
        new Permission('ViewPatientSession', 'View Patient Session')]),

    new ControlMenu(335, 'Emergency Room Setup', 315, [
        new Permission('ViewTriageScaleSetup', 'View Triage Scale Setup')]),

    new ControlMenu(336, 'Emergency Area', 82, [
        new Permission('ViewEmergencyArea', 'View Emergency Area')]),

    new ControlMenu(337, 'Pharmacy Setup', 315, [
        new Permission('ViewPharmacySetup', 'View Pharmacy Setup')]),

    new ControlMenu(338, 'Admission Setup', 315, [
        new Permission('ViewAdmissionSetup', 'View Admission Setup')]),

    new ControlMenu(339, 'Doctors Capacity', 83,
        [new Permission('ViewDoctorsCapacityManagement', 'View Doctors Capacity Management')]),

    new ControlMenu(340, 'Consultation Station', 57, [
        new Permission('ViewConsultationStation', 'View Consultation Station'),
        new Permission('AllowToSeeAllSpeciality', 'Allow To See All Speciality')]),

    new ControlMenu(342, 'Speciality Widget ', 315, [
        new Permission('ViewSpecialityWidgetSetup', 'View Speciality Widget Setup')
    ]),

    new ControlMenu(343, 'Transfer Consultation Request', 80, [
        new Permission('ViewTransferConsultationRequest', 'View Transfer Consultation Request')]),

    new ControlMenu(344, 'E-Claim Setup', 315, [
        new Permission('ViewEclaimSetup', 'View E-Claim Setup')]),

    new ControlMenu(345, 'Patient Master Index', 3, []),
    new ControlMenu(346, 'Patient Registration', 345, [
        new Permission('ViewPatientRegistration', 'View Patient Registration'),
        new Permission('EnableEditPatientRegistration', 'Enable Edit Patient Registration'),
        new Permission('EnableAddPatientRegistration', 'Enable Add Patient Registration'),
        new Permission('EnableBlockPatient', 'Enable Block Patient'),
        new Permission('EnableUnBlockPatient', 'Enable Un-Block Patient'),
        new Permission('AllowUserToRemoveAttachment', 'Allow User To Remove Attachment'),
        new Permission('AllowCheckEligibility', 'Allow Check Eligibility'),
        new Permission('AllowUserToAddDeposit', 'Allow User To Add Deposit'),
        new Permission('DisableInsuranceDate', 'Disable Insurance Date'),
        new Permission('DisableInsuranceAction', 'Disable Insurance Action'),
    ]),
    new ControlMenu(347, 'Check Eligibility', 345, [
        new Permission('ViewCheckEligibility', 'View Check Eligibility'),
    ]),

    new ControlMenu(348, 'Doctor Commission', 175, [
        new Permission('ViewDoctorCommission', 'View Doctor Commission')]),

    new ControlMenu(349, 'Approve Requests', 66, [
        new Permission('ViewApproveRequests', 'View Approve Requests')]),

    new ControlMenu(351, 'Appointment Setup', 315, [
        new Permission('ViewAppointmentSetup', 'View Appointment Setup')]),

    new ControlMenu(352, 'Sick Leave Station', 84, [
        new Permission('ViewSickLeaveStation', 'View Sick Leave Station')]),

    new ControlMenu(353, 'Receive ER Orders', 82, [
        new Permission('ViewReceiveEROrders', 'View Receive ER Orders'),
        new Permission('EnableOPDService', 'Enable OPD Service'),
        new Permission('AllowToShowErAccessMedicalProceduresReport', 'Access Medical Procedures Report'),
        new Permission('AllowToShowReceiveErAttachments', 'Attachments')
    ]),

    new ControlMenu(354, 'Authorization Transaction', 65, [
        new Permission('ViewAuthorizationTransaction', 'View Authorization Transaction')
    ]),

    new ControlMenu(355, 'FDA Setup', 337, [
        new Permission('ViewFDASetup', 'View FDA Setup')]),

    new ControlMenu(356, 'Auto Cash Discount Setup', 318, [
        new Permission('ViewAutoCashDiscountSetup', 'View Auto Cash Discount Setup')
    ]),

    new ControlMenu(357, 'View Auto Update Patient Visit And Statement Setup', 318, [
        new Permission('ViewAutoUpdatePatientVisitAndStatementSetup', 'View Auto Update Patient Visit And Statement Setup')
    ]),

    new ControlMenu(358, 'View Patient Deposit', 66, [
        new Permission('ViewPatientDeposit', 'View Patient Deposit'),]),

    new ControlMenu(359, 'View Document Alert Setup', 318, [
        new Permission('ViewDocumentAlertSetup', 'View Document Alert Setup')
    ]),

    new ControlMenu(359, 'Pricing Audit Management', 64, [
        new Permission('ViewPricingAuditManagement', 'View Pricing Audit Management')]),

    new ControlMenu(360, 'Deposit Transaction Management', 66, [
        new Permission('ViewDepositTransactionManagement', 'View Deposit Transaction Management'),
        new Permission('AllowEditDeposit', 'Allow Edit Deposit'),
    ]),

    new ControlMenu(361, 'View Close Invoice Management', 66, [
        new Permission('ViewCloseInvoiceManagement', 'View Close Invoice Management'),
        new Permission('EnablePatientStatement', 'Enable Patient Statement'),
        new Permission('EnterIssueDate', 'Enter Issue Date')]),

    new ControlMenu(362, 'Discontinue Transfer Medication Setup', 337, [
        new Permission('ViewDiscontinueTransferMedicationSetup', 'View Discontinue Transfer Medication Setup')]),


    new ControlMenu(363, 'Pending Area Managment', 14, [
        new Permission('ViewPendingAreaManagement', 'View Pending Area Managment'),
        new Permission('EnablePendingAreaManagementPatientStatement', 'Enable Patient Statement'),
        new Permission('AllowPendingAreaManagementUserToRelease', 'Allow User to Release'),
        new Permission('AllowPendingAreaManagementUserToCancel', 'Allow User to Cancel'),
        new Permission('AllowPendingAreaManagementUserToOverride', 'Allow User To Override'),
    ]),


    new ControlMenu(364, 'Pharmacy Pending Area Managment', 19, [
        new Permission('ViewPharmacyPendingAreaManagement', 'View Pharmacy Pending Area Managment'),
        new Permission('EnablePharmacyPendingAreaManagementPatientStatement', 'Enable Patient Statement'),
        new Permission('AllowPharmacyPendingAreaManagementUserToRelease', 'Allow User to Release'),
        new Permission('AllowPharmacyPendingAreaManagementUserToCancel', 'Allow User to Cancel'),
    ]),

    new ControlMenu(365, 'Patient Problem', 136, [
        new Permission('ViewPatientProblem', 'View Patient Problem')]),

    new ControlMenu(366, 'Doctor Experience Setup', 136, [
        new Permission('ViewDoctorExperienceSetup', 'View Doctor Experience Setup')]),

    new ControlMenu(367, 'Printer Setup', 318, [
        new Permission('ViewPrinterSetup', 'View Printer Setup')]),

    new ControlMenu(368, 'System Currency Setup', 318, [
        new Permission('ViewSystemCurrencySetup', 'View System Currency Setup')]),

    new ControlMenu(369, 'Vital Sign Setup', 315, [
        new Permission('ViewVitalSignSetup', 'View Vital Sign Setup')]),

    new ControlMenu(370, 'Audit Service', 2, [
    ]),

    new ControlMenu(371, 'Supply Chain', 370, []),

    new ControlMenu(372, 'Order Issue Stock', 371, [
        new Permission('ViewOrderIssueStock', 'View Order Issue Stock')]),

    new ControlMenu(373, 'Order Return Request', 371, [
        new Permission('ViewOrderReturnRequest', 'View Order Return Request')]),

    new ControlMenu(374, 'Patient Master Index Page', 345, [
        new Permission('ViewPatientMasterIndexPage', 'View Patient Master Index Page'),
    ]),

    new ControlMenu(375, 'link Services Sections Setup', 318, [
        new Permission('ViewlinkServicesSectionsSetup', 'View link Services Sections Setup')]),

    new ControlMenu(376, 'Operation Setup', 8, [
        new Permission('ViewOperationSetup', 'View Operation Setup')
    ]),

    new ControlMenu(377, 'Check List Definition', 8, [
        new Permission('ViewCheckListDefinition', 'View Check List Definition')
    ]),

    new ControlMenu(378, 'Instruments', 8, [
        new Permission('ViewInstruments', 'View Instruments')
    ]),

    new ControlMenu(379, 'Beds', 8, [
        new Permission('ViewOperationBeds', 'View Operation Beds')
    ]),

    new ControlMenu(380, 'ClaimAttachment', 199, [
        new Permission('ViewClaimAttachment', 'View Claim Attachment')]),

    new ControlMenu(381, 'Donor Station', 66, [
        new Permission('ViewDonorStation', 'View Donor Station')]),

    new ControlMenu(381, 'Issue Invoice Popup', 66, [
        new Permission('EnableCloseIssueInvoicePopup', 'Enable Close Issue Invoice Popup')]),

    new ControlMenu(382, 'Catering Management', 3, []),

    new ControlMenu(383, 'Meal Definitions', 382, [
        new Permission('ViewMealDefinitions', 'View Meal Definitions'),
    ]),

    new ControlMenu(384, 'Medical Services & Restrictions', 382, [
        new Permission('ViewMedicalServicesAndRestrictions', 'View Medical Services & Restrictions'),
    ]),

    new ControlMenu(385, 'Scheduled Meal Services', 382, [
        new Permission('ViewScheduledMealServices', 'View Scheduled Meal Services'),
    ]),

    new ControlMenu(386, 'Schedule Meal', 382, [
        new Permission('ViewScheduleMeal', 'View Schedule Meal'),
    ]),

    new ControlMenu(387, 'Section Meal Schedule Plan', 382, [
        new Permission('ViewSectionMealSchedulePlan', 'View Section Meal Schedule Plan'),
    ]),

    new ControlMenu(388, 'Scheduled Patient Station', 382, [
        new Permission('ViewScheduledPatientStation', 'View Scheduled Patient Station'),
    ]),

    new ControlMenu(389, 'Home Care Management', 4, [
        new Permission('ViewInPatientRequest', 'View In-Patient Request'),
        new Permission('ReceiveHomeCareNewRequestNotification', 'Receive Home Care New Request Notification'),
        new Permission('ViewDoctorStation', 'View Doctor Station'),
        new Permission('ViewTransportUnitRequestStation', 'View Transport Unit Request Station'),
        new Permission('ViewAdmissionStationHomeCare', 'View Admission Station'),
        new Permission('ViewTransportationUnits', 'View Transportation Units'),
        new Permission('ViewHomeCareSetup', 'View Home Care Setup'),
        new Permission('ViewOrderRequestServicesStation', 'View Order Request Services Station'),
    ]),

    new ControlMenu(391, 'Queue Management System', 3, [
        new Permission('ViewQueueMonitoring', 'View Queue Monitoring'),
        new Permission('ViewEducationalAttachment', 'View Educational Attachment'),
        new Permission('ViewNextPatient', 'View Next Patient')
    ]),

    new ControlMenu(392, ' System Code Constraint', 136, [
        new Permission('ViewSystemCodeConstraint', 'View System Code Constraint')]),
    new ControlMenu(393, 'Resources Station', 81, [
        new Permission('ViewResourcesStation', 'View Resources Station')]),
    new ControlMenu(394, 'Dictionary', 136, [
        new Permission('ViewDictionary', 'View Dictionary')]),

    new ControlMenu(394, 'Audit Transactions', 66, [
        new Permission('ViewAuditTransaction', 'View Audit Transaction')]),

    new ControlMenu(395, 'Arrive Appointment', 81,
        [new Permission('ViewArriveAppointment', 'View Arrive Appointment')]),

    new ControlMenu(396, 'Confirm Appointment', 81,
        [new Permission('ViewConfirmAppointment', 'View Confirm Appointment')]),

    new ControlMenu(397, 'Generate Patient MRN', 81,
        [new Permission('ViewGeneratePatientMRN', 'View Generate Patient MRN')]),

    new ControlMenu(398, 'Enable Add/Edit Insurance', 81,
        [new Permission('EnableAppointmentAddEditInsurance', 'Enable Add/Edit Insurance')]),

    new ControlMenu(399, 'Self Pay Patient Network ', 6, [
        new Permission('ViewSelfPayPatientNetwork', 'View Self Pay Patient Network')]),

    new ControlMenu(400, 'Vaccine Details', 136, [
        new Permission('ViewVaccineDetails', 'View Vaccine Details')]),

    new ControlMenu(401, 'Enable Override the Patient Payment Validation', 81,
        [new Permission('EnableOverrideThePatientPaymentValidation', 'Enable Override the Patient Payment Validation')]),

    new ControlMenu(402, 'Patient Order Billing Management Page', 345, [
        new Permission('ViewPatientOrderBillingManagementPage', 'View Patient Order Billing Management Page'),
        new Permission('AllowUpdatePatientOrderBillingInfo', 'Allow Update Patient Order Billing Info')
    ]),

    new ControlMenu(403, 'Survey Management', 3, [], environment.isSurveyMenuVisible),

    new ControlMenu(404, 'Survey Setup', 403, [
        new Permission('ViewSurveySetup', 'View Survey Setup')]),

    new ControlMenu(405, 'Survey Station', 403, [
        new Permission('ViewSurveyStation', 'View Survey Station')]),

    new ControlMenu(406, 'Tax Invoices Tracking', 173, [
        new Permission('ViewTaxInvoicesTracking', 'View Tax Invoices Tracking')]),

    new ControlMenu(407, 'Block Appointment', 81, [
        new Permission('BlockAppointment', 'Block Appointment')]),

    new ControlMenu(408, 'Quick Prescription Setup', 136, [
        new Permission('ViewQuickPrescriptionSetup', 'View Quick Prescription Setup')]),

    new ControlMenu(409, 'Staff Contact Access', 136, [
        new Permission('ViewStaffAccess', 'View Staff Contact Access')]),

    new ControlMenu(410, 'Supplementary Amount Setup', 318, [
        new Permission('ViewSupplementaryAmountSetup', 'View Supplementary Amount Setup')]),

    new ControlMenu(411, 'Patient Changes Log', 345, [
        new Permission('ViewpatientAuditLog', 'View Patient Changes Log')]),

    new ControlMenu(412, 'Daily Tax File Submission', 173, [
        new Permission('ViewDailyTaxFileSubmission', 'View Daily Tax File Submission')]),

    new ControlMenu(413, 'Failed Invoice Attachments Station', 199, [
        new Permission('ViewfailedInvoiceAttachmentsStation', 'View Failed Invoice Attachments Station')]),

    //EMR 
    new ControlMenu(541, 'EMR', 4, []),

    new ControlMenu(304, 'Landing Page', 541, [
        new Permission('AllowUserAction', 'Allow User Actions'),
        new Permission('AllowUserToDiscontinueDispenseMedication', 'Allow User To Discontinue Dispense Medication'),
        new Permission('AllowUpdateClosedMedicalRecord', 'Allow Update Closed Medical Record'),
        new Permission('AllowViewOnly', 'Allow View Only'),
        new Permission('ViewOncology', 'View Oncology'),
        new Permission('AllowUserToUpdateBlockedFile', 'Allow User To Update Blocked File'),
        new Permission('PreventOtherDoctorToUpdateFollowUp', 'Prevent Other Doctor To Update Follow Up'),
        new Permission('AllowUserToRemovePatientAttachment', 'Allow User To Remove Patient Attachment'),
        new Permission('AllowUserToAddRadiologyReport', 'Allow User To Add Radiology Report'),
        new Permission('AllowUserToUpdateRadiologyReport', 'Allow User To Update Radiology Report'),
        new Permission('AllowConsultationDoctorToOrder', 'Allow Consultation Doctor To Order'),
        new Permission('EnablePatientMedicalHistory', 'Enable Patient Medical History'),
        new Permission('AllowUserToApproveMedicalProceduresReport', 'Approved Medical Procedures Report'),
    ]),

    new ControlMenu(542, 'Physician Order', 541, []),

    new ControlMenu(270, 'Patient Station', 542, [
        new Permission('ViewPatientStation', 'View Patient Station'),
        new Permission('AllowSearchAllPatient', 'Allow Search All Patients'),
        new Permission('ViewReasonToOpenMedicalFileToUnassignedDoctor', 'View Reason To Open Medical File To Unassigned Doctor'),
        new Permission('ViewReasontoopenCloseMedicalFile', 'View Reason to open Close Medical File'),
        new Permission('ViewAppointmentRequestPage', 'View Appointment Request Page')
    ]),

    new ControlMenu(134, 'Doctor First Net Summary', 542, [
        new Permission('ViewDoctorDesktop', 'View Doctor Desktop')]),

    new ControlMenu(62, 'Physician Desktop', 542, [
        new Permission('ViewPhysicianDesktop', 'View Physician Desktop'),
        new Permission('AllowAllPatients', 'Allow All Patients'),
        new Permission('AllowUserToApproveRequest', 'Allow User to Approve Request'),
    ]),
    new ControlMenu(415, 'Physician Order Item', 542, [
        new Permission('ViewAttachment', 'View Attachment'),
        new Permission('AllowAccessMedicalProceduresReport', 'Allow Access Medical Procedures Report'),
    ]),

    new ControlMenu(562, 'Order Folders', 542, [
        new Permission('ManageOrderFoldersForAll', 'Add or Delete Order Folders For All Users'),
        new Permission('ManageOwnOrderFolders', 'Add or Delete Own Order Folders'),
    ]),
    //END OF EMR

    new ControlMenu(414, 'Delta Check Configuration', 30, [
        new Permission('ViewDeltaCheckConfiguration', 'View Delta Check Configuration')]),

    new ControlMenu(543, 'Quick Dispense Outpatient Pharmacy', 19, [
        new Permission('ViewQuickDispenseOutpatientPharmacy', 'View Quick Dispense Outpatient Pharmacy'),

    ]),
    new ControlMenu(544, 'Dental Treatment Plan Management', 14, [
        new Permission('ViewDentalTreatmentPlanManagement', 'View Dental Treatment Plan Management')
    ]),
];
